import { useWindowSize } from 'usehooks-ts';

const BREAKPOINT = 768;

const useScreenSize = () => {
  const { width } = useWindowSize();
  return {
    isMobile: width < BREAKPOINT,
    isDesktop: width >= BREAKPOINT,
  };
};

export default useScreenSize;
